import { useEffect, useRef } from "react";
import type { UserData } from "@/pages/Index";
import { decorateShopUrl } from "@/lib/tracking";

const QUIZ_WEBHOOK_URL = 'https://ejepfwphnjtvoegtswjd.supabase.co/functions/v1/quiz-webhook?quiz=huidanalyse';

interface NotSuitableProps {
  userData: UserData;
}

const NotSuitable = ({ userData }: NotSuitableProps) => {
  const sentRef = useRef(false);

  useEffect(() => {
    if (sentRef.current) return;
    sentRef.current = true;

    const sessionId = sessionStorage.getItem('quiz_session_id') || crypto.randomUUID();
    const answers = [
      { question: "Leeftijd", answer: userData.age },
      { question: "Veiligheidscheck", answer: userData.safetyFlags.join(', ') },
    ].filter(a => a.answer && a.answer.trim() !== '');

    fetch(QUIZ_WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        quiz_name: 'huidanalyse',
        session_id: sessionId,
        outcome: 'not_suitable',
        safety_flags: userData.safetyFlags,
        answers,
      }),
    }).catch(() => {});
  }, [userData]);

  return (
    <div className="text-center">
      <div className="insight-card text-left">
        <h2 className="text-2xl md:text-4xl font-serif font-medium text-foreground mb-6 leading-tight text-center">
          Bedankt voor je eerlijkheid
        </h2>

        <p className="text-foreground font-sans text-lg leading-relaxed mb-5">
          Op basis van wat je hebt aangegeven, raden we je aan SkinFuse niet te gebruiken zonder overleg met je arts of dermatoloog. Micro-needling kan bij couperose, rosacea, actief eczeem of een zeer reactieve huid tot complicaties leiden, waaronder langdurige roodheid, irritatie of zelfs permanente broken capillaries. Ook bij gebruik van bloedverdunners of na een recente huidbehandeling is voorzichtigheid geboden. We willen liever eerlijk zijn dan jou een product verkopen dat niet bij jouw huid past.
        </p>

        <p className="text-foreground font-sans text-lg leading-relaxed">
          Wat we je wel adviseren: bespreek je situatie met een dermatoloog. Zij kunnen je doorverwijzen naar behandelingen die specifiek geschikt zijn voor jouw huidtype. Je huidgezondheid komt altijd op de eerste plaats.
        </p>
      </div>

      <div className="mt-8">
        <a
          href={decorateShopUrl("https://adelira.nl")}
          target="_blank"
          rel="noopener noreferrer"
          className="text-foreground/70 font-sans text-base underline hover:text-foreground transition-colors"
        >
          Terug naar de website
        </a>
      </div>
    </div>
  );
};

export default NotSuitable;
